import { NgModule } from '@angular/core';
import { IsFirstChoiceSelectedPipe } from './is-first-choice-selected.pipe';
import { IsSecondChoiceSelectedPipe } from './is-second-choice-selected.pipe';

@NgModule({
  declarations: [IsFirstChoiceSelectedPipe, IsSecondChoiceSelectedPipe],
  exports: [IsFirstChoiceSelectedPipe, IsSecondChoiceSelectedPipe],
})
export class FlightPreferencePipesModule {}
